import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "업그레이드",
  "description": "저장소에 최신 개선 사항을 적용하기 위해 `turbo`를 업그레이드하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "turbojson-업데이트",
    "content": "다음을 실행하여 1.x에서 2.0으로 업그레이드를 시작합니다:"
  }, {
    "heading": "turbojson-업데이트",
    "content": "이는 1.x에서 2.0으로의 많은 주요 변경 사항에 대해 turbo.json을 업데이트합니다."
  }, {
    "heading": "turbojson-업데이트",
    "content": "또한 name 필드가 없는 Workspace의 모든 package.json에 name 필드가 추가됩니다."
  }, {
    "heading": "turbojson-업데이트",
    "content": "각 codemod를 개별적으로 수동으로 실행할 수도 있습니다. 자세한 내용은 codemods\n페이지를 방문하세요."
  }, {
    "heading": "루트-packagejson에-packagemanager-필드-추가",
    "content": "packageManager 필드는 Workspace에서 사용해야 하는 패키지 관리자를 정의하는 Node.js 생태계의 규칙입니다."
  }, {
    "heading": "루트-packagejson에-packagemanager-필드-추가",
    "content": "Turborepo 2.0은 코드베이스의 안정성과 동작 예측 가능성을 향상시키는 방법으로 Workspace가 이 필드를 정의하도록 요구합니다. 아직 없는 경우 루트 package.json에 이 필드를 추가합니다:"
  }, {
    "heading": "eslint-config-turbo-업데이트",
    "content": "eslint-config-turbo는 캐싱을 위해 env 키에 추가해야 하는 환경 변수를 식별하는 데 도움이 됩니다. 사용 중인 경우 메이저 버전과 일치하도록 업데이트해야 합니다."
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "Turborepo 2.0에는 turbo run 명령의 동작 및 정확성 개선이 포함되어 있습니다. 아래는 변경 사항의 요약이며, 코드베이스에 영향을 미칠 수도 있고 그렇지 않을 수도 있습니다:"
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "환경 변수에 대한 Strict Mode가 이제 기본값이 되어 Loose Mode에서 이동함 (PR)"
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "작업의 스크립트에 환경 변수가 누락된 것으로 보이면 명령별로 --env-mode 옵션을 사용하여 이 동작에서 다시 옵트아웃하여 점진적으로 마이그레이션할 수 있습니다. 가능한 한 빨리 --env-mode 옵션을 삭제할 수 있도록 작업의 모든 환경 변수를 고려하도록 the env 키를 업데이트하는 것이 좋습니다."
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "저장소의 기본값을 Loose Mode로 다시 설정하려면 envMode 구성을 사용하여 설정할 수 있습니다."
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "Workspace 루트 디렉토리는 이제 모든 패키지의 암시적 종속성임 (PR)"
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "루트의 변경 사항이 저장소의 모든 작업에 영향을 줄 수 있으므로 저장소는 루트에 가능한 한 적은 코드를 가져야 합니다. 또한 Workspace 루트에서 Internal Package를 사용하는 경우 해당 종속성에 대한 변경 사항도 모든 작업에 대한 캐시 미스를 유발합니다. 두 경우 모두 루트에서 코드를 이동하고 패키지로 이동하는 것을 고려하세요."
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "--filter 및 아래 그래프 정확성 변경을 위해 --ignore 제거됨 (PR)"
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "--scope 플래그 제거됨 (1.2부터 더 이상 사용되지 않음) (PR)"
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "루트 package.json의 engines 필드가 이제 해싱에 사용됨 (PR)"
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "--filter가 더 이상 패키지 이름에 대한 네임스페이스를 추론하지 않음 (PR)"
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "--filter는 이제 패키지 이름이나 디렉토리가 일치하지 않을 때 오류를 발생함 (PR)"
  }, {
    "heading": "turbo-run-명령-업데이트",
    "content": "--only는 패키지 종속성 대신 작업 종속성을 제한함 (PR)"
  }],
  "headings": [{
    "id": "20으로-업그레이드",
    "content": "2.0으로 업그레이드"
  }, {
    "id": "turbojson-업데이트",
    "content": "turbo.json 업데이트"
  }, {
    "id": "루트-packagejson에-packagemanager-필드-추가",
    "content": "루트 package.json에 packageManager 필드 추가"
  }, {
    "id": "eslint-config-turbo-업데이트",
    "content": "eslint-config-turbo 업데이트"
  }, {
    "id": "turbo-run-명령-업데이트",
    "content": "turbo run 명령 업데이트"
  }]
};
import {PackageManagerTabs, Tab} from '#components/tabs';
import {Steps, Step} from '#components/steps';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#20으로-업그레이드",
  title: _jsx(_Fragment, {
    children: "2.0으로 업그레이드"
  })
}, {
  depth: 3,
  url: "#turbojson-업데이트",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo.json"
    }), " 업데이트"]
  })
}, {
  depth: 3,
  url: "#루트-packagejson에-packagemanager-필드-추가",
  title: _jsxs(_Fragment, {
    children: ["루트 ", _jsx("code", {
      children: "package.json"
    }), "에 ", _jsx("code", {
      children: "packageManager"
    }), " 필드 추가"]
  })
}, {
  depth: 3,
  url: "#eslint-config-turbo-업데이트",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "eslint-config-turbo"
    }), " 업데이트"]
  })
}, {
  depth: 3,
  url: "#turbo-run-명령-업데이트",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo run"
    }), " 명령 업데이트"]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "20으로-업그레이드",
      children: "2.0으로 업그레이드"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "turbojson-업데이트",
          children: [_jsx(_components.code, {
            children: "turbo.json"
          }), " 업데이트"]
        }), _jsx(_components.p, {
          children: "다음을 실행하여 1.x에서 2.0으로 업그레이드를 시작합니다:"
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @turbo/codemod"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " migrate"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @turbo/codemod"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " migrate"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @turbo/codemod"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " migrate"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bunx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @turbo/codemod"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " migrate"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["이는 1.x에서 2.0으로의 많은 주요 변경 사항에 대해 ", _jsx(_components.code, {
            children: "turbo.json"
          }), "을 업데이트합니다."]
        }), _jsxs(_components.p, {
          children: ["또한 ", _jsx(_components.code, {
            children: "name"
          }), " 필드가 없는 Workspace의 모든 ", _jsx(_components.code, {
            children: "package.json"
          }), "에 ", _jsx(_components.code, {
            children: "name"
          }), " 필드가 추가됩니다."]
        }), _jsx(Callout, {
          type: "good-to-know",
          children: _jsxs(_components.p, {
            children: ["각 codemod를 개별적으로 수동으로 실행할 수도 있습니다. 자세한 내용은 ", _jsx(_components.a, {
              href: "/docs/reference/turbo-codemod#turborepo-2x",
              children: "codemods\n페이지"
            }), "를 방문하세요."]
          })
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "루트-packagejson에-packagemanager-필드-추가",
          children: ["루트 ", _jsx(_components.code, {
            children: "package.json"
          }), "에 ", _jsx(_components.code, {
            children: "packageManager"
          }), " 필드 추가"]
        }), _jsxs(_components.p, {
          children: [_jsxs(_components.a, {
            href: "https://nodejs.org/api/packages.html#packagemanager",
            children: [_jsx(_components.code, {
              children: "packageManager"
            }), " 필드"]
          }), "는 Workspace에서 사용해야 하는 패키지 관리자를 정의하는 Node.js 생태계의 규칙입니다."]
        }), _jsxs(_components.p, {
          children: ["Turborepo 2.0은 코드베이스의 안정성과 동작 예측 가능성을 향상시키는 방법으로 Workspace가 이 필드를 정의하도록 요구합니다. 아직 없는 경우 루트 ", _jsx(_components.code, {
            children: "package.json"
          }), "에 이 필드를 추가합니다:"]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ \"packageManager\": \"pnpm@9.2.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ \"packageManager\": \"yarn@1.22.19\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ \"packageManager\": \"npm@10.8.1\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ \"packageManager\": \"bun@1.2.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "eslint-config-turbo-업데이트",
          children: [_jsx(_components.code, {
            children: "eslint-config-turbo"
          }), " 업데이트"]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/reference/eslint-config-turbo",
            children: _jsx(_components.code, {
              children: "eslint-config-turbo"
            })
          }), "는 캐싱을 위해 ", _jsx(_components.a, {
            href: "/docs/reference/configuration#env",
            children: _jsx(_components.code, {
              children: "env"
            })
          }), " 키에 추가해야 하는 환경 변수를 식별하는 데 도움이 됩니다. 사용 중인 경우 메이저 버전과 일치하도록 업데이트해야 합니다."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "turbo-run-명령-업데이트",
          children: [_jsx(_components.code, {
            children: "turbo run"
          }), " 명령 업데이트"]
        }), _jsxs(_components.p, {
          children: ["Turborepo 2.0에는 ", _jsx(_components.code, {
            children: "turbo run"
          }), " 명령의 동작 및 정확성 개선이 포함되어 있습니다. 아래는 변경 사항의 요약이며, 코드베이스에 영향을 미칠 수도 있고 그렇지 않을 수도 있습니다:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["환경 변수에 대한 Strict Mode가 이제 기본값이 되어 Loose Mode에서 이동함 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8182",
              children: "PR"
            }), ")", "\n", _jsxs(_components.ul, {
              children: ["\n", _jsxs(_components.li, {
                children: ["작업의 스크립트에 환경 변수가 누락된 것으로 보이면 명령별로 ", _jsxs(_components.a, {
                  href: "/docs/reference/run#--env-mode-option",
                  children: [_jsx(_components.code, {
                    children: "--env-mode"
                  }), " 옵션"]
                }), "을 사용하여 이 동작에서 다시 옵트아웃하여 점진적으로 마이그레이션할 수 있습니다. 가능한 한 빨리 ", _jsx(_components.code, {
                  children: "--env-mode"
                }), " 옵션을 삭제할 수 있도록 작업의 모든 환경 변수를 고려하도록 ", _jsxs(_components.a, {
                  href: "/docs/reference/configuration#env",
                  children: ["the ", _jsx(_components.code, {
                    children: "env"
                  }), " 키"]
                }), "를 업데이트하는 것이 좋습니다."]
              }), "\n", _jsxs(_components.li, {
                children: ["저장소의 기본값을 Loose Mode로 다시 설정하려면 ", _jsxs(_components.a, {
                  href: "/docs/reference/configuration#envmode",
                  children: [_jsx(_components.code, {
                    children: "envMode"
                  }), " 구성"]
                }), "을 사용하여 설정할 수 있습니다."]
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["Workspace 루트 디렉토리는 이제 모든 패키지의 암시적 종속성임 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8202",
              children: "PR"
            }), ")", "\n", _jsxs(_components.ul, {
              children: ["\n", _jsxs(_components.li, {
                children: ["루트의 변경 사항이 저장소의 모든 작업에 영향을 줄 수 있으므로 저장소는 루트에 가능한 한 적은 코드를 가져야 합니다. 또한 Workspace 루트에서 ", _jsx(_components.a, {
                  href: "/docs/core-concepts/internal-packages",
                  children: "Internal Package"
                }), "를 사용하는 경우 해당 종속성에 대한 변경 사항도 모든 작업에 대한 캐시 미스를 유발합니다. 두 경우 모두 루트에서 코드를 이동하고 ", _jsx(_components.a, {
                  href: "/docs/crafting-your-repository/structuring-a-repository",
                  children: "패키지로 이동"
                }), "하는 것을 고려하세요."]
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "--filter"
            }), " 및 아래 그래프 정확성 변경을 위해 ", _jsx(_components.code, {
              children: "--ignore"
            }), " 제거됨 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8201",
              children: "PR"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "--scope"
            }), " 플래그 제거됨 (1.2부터 더 이상 사용되지 않음) (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/7970",
              children: "PR"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["루트 ", _jsx(_components.code, {
              children: "package.json"
            }), "의 ", _jsx(_components.code, {
              children: "engines"
            }), " 필드가 이제 해싱에 사용됨 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8173",
              children: "PR"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "--filter"
            }), "가 더 이상 패키지 이름에 대한 네임스페이스를 추론하지 않음 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8137",
              children: "PR"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "--filter"
            }), "는 이제 패키지 이름이나 디렉토리가 일치하지 않을 때 오류를 발생함 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8142",
              children: "PR"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "--only"
            }), "는 패키지 종속성 대신 작업 종속성을 제한함 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8163",
              children: "PR"
            }), ")"]
          }), "\n"]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
